<template>
  <sub-section
    title="Want to leave some money to pass on if possible?"
    helpTitle="Protected pot"
    :helpText="HelpText.protectedPot()"
  >
    <div class="row">
      <div class="col">
        <label for="protectedPot">Protected pot: {{ protectedPotText }}</label>
        <input
          ref="protectedPotSlider"
          type="range"
          class="form-range"
          id="protectedPot"
          v-model="protectedPotModel"
          min="0"
          :max="maxProtectedPot"
          step="1000"
          @keypress="onProtectedPotKeyPress($event)"
          @change="onProtectedPotChange"
        />
      </div>
    </div>
  </sub-section>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import HelpText from "@/guiide/ts/helpText";
import { formatter } from "@/shared/ts/formatter";
import { app } from "@/guiide/ts/app";

export default defineComponent({
  name: "LeavePotsUntouched",
  components: {
    SubSection
  },
  setup() {
    const protectedPotSlider = ref(null);
    const protectedPotModel = ref(0);
    return {
      protectedPotSlider,
      protectedPotModel,
      HelpText
    };
  },
  watch: {
    storeRetireeProtectedPot(value: null | number) {
      this.protectedPotModel = value ?? 0;
    }
  },
  computed: {
    maxProtectedPot: function(): number {
      return (
        this.$store.state.retiree?.pensionPots.valueLessAnyDeductions ?? 10000
      );
    },
    protectedPotText: function(): string {
      return formatter.formatCurrency(this.protectedPotModel);
    },
    storeRetireeProtectedPot: function(): null | number {
      return this.$store.state.retiree?.protectedPot;
    }
  },
  methods: {
    onProtectedPotKeyPress(event) {
      event.preventDefault();
    },
    async onProtectedPotChange() {
      if (
        this.storeRetireeProtectedPot == null ||
        this.protectedPotModel == this.storeRetireeProtectedPot
      ) {
        return;
      }

      this.protectedPotSlider.disabled = true;
      await app.updateProtectedPot(this.protectedPotModel);
      this.protectedPotSlider.disabled = false;
    },
    setDisabledState(disabled: boolean) {
      this.protectedPotSlider.disabled = disabled;
    }
  }
});
</script>
